import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "title", "updateMessage", "deleteMessage", "updateAlert", "deleteAlert", "updateButton", "deleteButton"]
  
  // We'll store the caller controller as a property, not a value
  // since Stimulus values can't store objects

  connect() {
    // Add event listener for ESC key
    document.addEventListener('keydown', this.keydown.bind(this))
  }
  
  disconnect() {
    // Remove event listeners when controller is disconnected
    document.removeEventListener('keydown', this.keydown.bind(this))
  }
  
  configure(options = {}) {
    // Set title if provided
    if (options.title && this.hasTitleTarget) {
      this.titleTarget.textContent = options.title
    }
    
    // Set message if provided
    if (options.message) {
      if (options.actionType === 'delete' && this.hasDeleteMessageTarget) {
        this.deleteMessageTarget.innerHTML = options.message
      } else if (this.hasUpdateMessageTarget) {
        this.updateMessageTarget.innerHTML = options.message
      }
    }
    
    // Toggle appropriate alert and button based on action type
    if (options.actionType === 'delete') {
      // Show delete alert and button, hide update alert and button
      if (this.hasDeleteAlertTarget) this.deleteAlertTarget.classList.remove('hidden')
      if (this.hasUpdateAlertTarget) this.updateAlertTarget.classList.add('hidden')
      if (this.hasDeleteButtonTarget) this.deleteButtonTarget.classList.remove('hidden')
      if (this.hasUpdateButtonTarget) this.updateButtonTarget.classList.add('hidden')
    } else {
      // Show update alert and button, hide delete alert and button
      if (this.hasUpdateAlertTarget) this.updateAlertTarget.classList.remove('hidden')
      if (this.hasDeleteAlertTarget) this.deleteAlertTarget.classList.add('hidden')
      if (this.hasUpdateButtonTarget) this.updateButtonTarget.classList.remove('hidden')
      if (this.hasDeleteButtonTarget) this.deleteButtonTarget.classList.add('hidden')
    }
    
    // Set button text if provided
    if (options.buttonText) {
      if (options.actionType === 'delete' && this.hasDeleteButtonTarget) {
        this.deleteButtonTarget.textContent = options.buttonText
      } else if (this.hasUpdateButtonTarget) {
        this.updateButtonTarget.textContent = options.buttonText
      }
    }
    
    // Store the caller controller if provided
    if (options.callerController) {
      this.callerController = options.callerController
    }
  }
  
  open() {
    if (this.hasDialogTarget) {
      this.dialogTarget.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }
  }
  
  closeDialog() {
    if (this.hasDialogTarget) {
      this.dialogTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
      this.callerController = null
    }
  }
  
  backgroundClick(event) {
    if (event.target === this.dialogTarget) {
      this.closeDialog()
    }
  }
  
  keydown(event) {
    if (event.key === "Escape") {
      this.closeDialog()
    }
  }
  
  confirmAction() {
    // Check if we have a caller controller
    if (this.callerController) {
      // Call the confirmAction method if it exists
      if (typeof this.callerController.confirmAction === 'function') {
        this.callerController.confirmAction()
        
        // Close the dialog
        this.closeDialog()
        return
      }
    }
    
    // If we get here, we couldn't find a caller controller
    console.error('No caller controller found for confirmation dialog')
    this.closeDialog()
  }
}
